module.exports = __webpack_public_path__ + "static/washington-291f1eb5ac22f4765226b031b5914124.png";